import { MemberMap } from '@nextforce/api'
import { useTheme } from '@rneui/themed'
import { t } from 'app/i18l'
import { filterMembers } from 'chat/members/recipients/util'
import { SelectMembersView } from 'chat/members/views/select'
import { CrewMemberFilterScreenProps } from 'home/stack/types'
import { isEqual } from 'lodash'
import React, { useEffect, useLayoutEffect, useMemo, useState } from 'react'
import Spinner from 'shared/components/spinner'
import { StatusBoundary } from 'shared/components/status_boundary'
import { EmptyUserListView } from 'shared/components/user/empty_user_list'
import { showHeaderButton } from 'shared/header/header_button'
import { useRecentStoresContext } from 'stores/context'
import { useUserList } from 'users/queries/list'
import { useFiltersContext } from '../context'

export function CrewMemberFilterScreen({
  route,
  navigation,
}: CrewMemberFilterScreenProps) {
  const { theme } = useTheme()
  const { activeStoreId } = useRecentStoresContext()

  const { currentFilters, setCrewMemberFilter, setCurrentSelectedPresetIndex } =
    useFiltersContext()

  const [members, setMembers] = useState<MemberMap>({})
  const [loading, setLoading] = useState<boolean>(false)
  const [searchText, setSearchText] = useState<string>('')

  const currentCrewMembersIds = currentFilters.crewMembers.selectedIds

  const userListQuery = useUserList({ type: 'scheduled' }, activeStoreId)

  const users = useMemo(
    () => filterMembers(userListQuery.data?.users, searchText),
    [searchText, userListQuery.data?.users]
  )
  useEffect(() => {
    if (users && users.length > 0) {
      const memberMap: MemberMap = {}
      const selectedMembers = users.filter(user =>
        currentCrewMembersIds.includes(user.id)
      )
      selectedMembers.forEach(member => {
        memberMap[member.id] = member
      })
      setMembers(memberMap)
    }
  }, [currentCrewMembersIds, currentFilters.crewMembers.selectedIds, users])

  useLayoutEffect(
    () =>
      showHeaderButton({
        navigation,
        theme,
        title: t('done'),
        onPress: async () => {
          setLoading(true)
          if (!isEqual(Object.keys(members), currentCrewMembersIds)) {
            setCrewMemberFilter(members)
            setCurrentSelectedPresetIndex(undefined)
          }
          navigation.goBack()
        },
      }),
    [
      currentCrewMembersIds,
      members,
      navigation,
      setCrewMemberFilter,
      setCurrentSelectedPresetIndex,
      theme,
    ]
  )

  return (
    <StatusBoundary
      isLoading={userListQuery.isLoading}
      error={userListQuery.error}
    >
      {loading ? (
        <Spinner />
      ) : users && users.length === 0 ? (
        <EmptyUserListView />
      ) : (
        <SelectMembersView
          recipients={users}
          onMembersSelected={setMembers}
          selectedMembers={members}
          searchText={searchText}
          setSearchText={setSearchText}
        />
      )}
    </StatusBoundary>
  )
}
